function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'mkui-fd';
export default function SelectedItem(props) {
  var _rootCls;

  var onRemove = props.onRemove,
      prefixCls = props.prefixCls,
      disabled = props.disabled,
      name = props.name,
      multiple = props.multiple,
      removeBtn = props.removeBtn,
      icon = props.icon;
  var rootCls = (_rootCls = {}, _defineProperty(_rootCls, prefixCls, 1), _defineProperty(_rootCls, "".concat(prefixCls, "-remove-btn"), removeBtn), _defineProperty(_rootCls, "".concat(prefixCls, "-multiple"), multiple), _rootCls);

  function removeHandle(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!disabled) {
      onRemove();
    }
  }

  return React.createElement("li", {
    className: classNames(rootCls),
    title: name
  }, React.createElement("span", null, name), React.createElement(Button, {
    type: "danger",
    shape: "clear",
    icon: "trash",
    onClick: function onClick(event) {
      removeHandle(event);
    }
  }));
}
SelectedItem.propTypes = {
  prefixCls: PropTypes.string
};
SelectedItem.defaultProps = {
  prefixCls: 'mkui-transfer-modal-item'
};
//# sourceMappingURL=SelectedItem.js.map
